export const STALE_ASSET_RELOAD_KEY = "asr-stale-asset-reload";

const STALE_MODULE_FAILURE_PATTERNS: readonly string[] = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "is not a valid JavaScript MIME type",
  "error loading dynamically imported module",
  "Loading chunk",
];

export function isStaleAssetUrl(url: string, origin: string = window.location.origin): boolean {
  try {
    const parsed = new URL(url, origin);
    return parsed.origin === origin && parsed.pathname.startsWith("/assets/");
  } catch {
    return false;
  }
}

export function isStaleModuleFailureMessage(message: string): boolean {
  return STALE_MODULE_FAILURE_PATTERNS.some((pattern) => message.includes(pattern));
}

export function reloadOnceForStaleAssets(
  storage: Pick<Storage, "getItem" | "setItem"> | null = typeof sessionStorage === "undefined"
    ? null
    : sessionStorage,
  reload: () => void = () => window.location.reload(),
): boolean {
  if (!storage) {
    return false;
  }
  try {
    if (storage.getItem(STALE_ASSET_RELOAD_KEY) === "1") {
      return false;
    }
    storage.setItem(STALE_ASSET_RELOAD_KEY, "1");
    reload();
    return true;
  } catch {
    return false;
  }
}

export function clearStaleAssetReloadFlag(
  storage: Pick<Storage, "removeItem"> | null = typeof sessionStorage === "undefined"
    ? null
    : sessionStorage,
): void {
  if (!storage) {
    return;
  }
  try {
    storage.removeItem(STALE_ASSET_RELOAD_KEY);
  } catch {
    // Private mode / blocked storage.
  }
}

export function installStaleAssetReloadHandlers(target: Window = window): void {
  target.addEventListener(
    "vite:preloadError",
    ((event: Event) => {
      event.preventDefault();
      reloadOnceForStaleAssets();
    }) as EventListener,
  );

  target.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason ?? "");
    if (!isStaleModuleFailureMessage(message)) {
      return;
    }
    event.preventDefault();
    reloadOnceForStaleAssets();
  });
}
